import { ConfirmDialogContent } from 'src/nightingale/components/ChartInteraction/ChartInteractionConfirmDialogContext';

export const hideChartElementDialogContent = (
  showDialog: (content: ConfirmDialogContent) => void,
  onConfirm: () => void,
) =>
  showDialog({
    title: 'Are you sure?',
    message:
      "Hiding a problem will remove it from today's visit note but keep it on the patient's chart for future visits.\n\nIt is appropriate to hide a problem that is still relevant to the patient but isn't being addressed during today's visit.",
    prompt: "Do you want to hide this problem from today's visit?",
    onConfirm,
  });

export const clearChartElementDialogContent = (
  showDialog: (content: ConfirmDialogContent) => void,
  onConfirm: () => void,
) =>
  showDialog({
    title: 'Are you sure?',
    message:
      "Clearing a problem will remove it from the patient's chart entirely. It will not change signed visit notes.",
    prompt: 'Do you want to delete this diagnosis and associated charting from the patient chart?',
    onConfirm,
  });
